<div class="row mb-4">
    <div class="col-lg-6">
        <h4 class="mb-3">Rate this meeting</h4>
        <div class="star-rating">
            @for (star of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]; track star; let i = $index) {
                <span
                    class="star"
                    [class.active]="isStarActive(star)"
                    (click)="setRating(star)"
                    (mouseenter)="onStarHover(star)"
                    (mouseleave)="onStarLeave()"
                    [title]="star + ' star' + (star > 1 ? 's' : '')"
                >
                    ★
                </span>
            }
        </div>
        @if (selectedRating > 0) {
            <div class="rating-text mt-2">
                <small class="text-muted">You rated this meeting {{ selectedRating }} star{{ selectedRating > 1 ? 's' : '' }}</small>
            </div>
        }
    </div>

    <div class="col-lg-6">
        <h4 class="mb-3">Meeting Minutes</h4>
        <div class="meeting-minutes">
            @for (pageTime of pageTimes(); track pageTime; let i = $index) {
                <div class="row mb-1">
                    <div class="col-8">
                        <strong>{{ pageTime.page.title }}</strong>
                    </div>
                    <div class="col-4 text-end">
                        <span class="badge bg-primary">{{ pageTime.timeFormatted }}</span>
                    </div>
                </div>
            }
            <!-- Total Meeting Time Row -->
            <div class="row mb-1">
                <div class="col-8">
                    <strong>Total Meeting Time</strong>
                </div>
                <div class="col-4 text-end">
                    <span class="badge bg-success">{{ totalMeetingTime().timeFormatted }}</span>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="row">
    <div class="col-12">
        <h4 class="mb-3">To-Do Recap</h4>
        <app-to-dos [meetingId]="meetingId()" [meetings]="meetings()" [meeting]="meeting()"></app-to-dos>
    </div>
</div>
